import { AfterViewInit, Component, Inject, OnInit, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { ApiService } from '@services/api.service';
import { TranslatePipe } from '@pipes/translate.pipe';
import { LocalizationService } from '@services/localization.service';
import { DataHelper } from '@helpers/data.helper';
import { IsoCountriesPipe } from '@pipes/isoCountries.pipe';
import { UiHelper } from '@helpers/ui.helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { StandingsDialogComponent } from './standings.dialog.component';
import { sportsSvgList } from '@app/constants/svgUrl.constant';

@Component({
  selector: 'left-sport-menu-desktop',
  templateUrl: '../sharedTemplates/left-sport-menu.desktop.html',
})
export class LeftSportMenuDesktop implements AfterViewInit, OnInit {
  public sportsSvgList = sportsSvgList;
  favoriteList = [];
  mainData = [];
  _dayFilter = 300;
  lastReturned_dayFilter = 0;
  selectedLeagueData = [];
  searchState = false;
  searchFb: UntypedFormGroup;
  @Output() favPreMatchesClicked = new EventEmitter();

  constructor(
    private _ApiService: ApiService,
    private _LocalizationService: LocalizationService,
    private _DataHelper: DataHelper,
    public _Router: Router,
    public _UiHelper: UiHelper,
    private _fbuilder: UntypedFormBuilder,
    private _ActivatedRoute: ActivatedRoute,
    public dialog: MatDialog
  ) {
    this.searchFb = _fbuilder.group({
      searchInput: new UntypedFormControl({ value: '', disabled: false }),
    });

    //console.log('ngAfterViewInit--LeagueData',this._DataHelper.LeagueData);

    this._DataHelper.LeagueDataListener.subscribe(x => {
      //console.log('subscribe--LeagueData',this._DataHelper.LeagueData);
      if (this._DataHelper.LeagueData != undefined) {
        this.selectedLeagueData = this._DataHelper.LeagueData;
      }
    });
  }

  changeDayFilter(e) {
    // //console.log("changeDayFilter",e);
    // //console.log("this._dayFilter",this._dayFilter);
    if (e.value == undefined) {
      return;
    }

    this._DataHelper.leftMenuSportDayFilter = e.value;
    // this.getSports(e.value);

    if (this._dayFilter != e.value) {
      e != undefined ? this.getSports(e.value) : null;
      this._dayFilter = e.value;
    }
  }

  selectedLeague(e, item2) {
    //console.log('--e--',e);
    //console.log('--item2--',item2);

    //console.log('-LEFT_MENU-selectedLeagueData--',this.selectedLeagueData);

    const ixoftor = this.selectedLeagueData.indexOf(x => x.TournamentId == e.source.value.TournamentId);

    //////console.warn(this.selectedLeagueData, e.source.value.TournamentId, ixoftor);

    if (this.selectedLeagueData.find(x => x.TournamentId == e.source.value.TournamentId) == undefined) {
      this.selectedLeagueData.push(e.source.value);
    } else {
      this.selectedLeagueData = this.selectedLeagueData.filter(x => x.TournamentId != e.source.value.TournamentId);
    }

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    if (!e.source.checked) {
      item2.allselected = false;
    }

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  openLeague(sport, tournament, category) {
    this.selectedLeagueData = [];

    const data = {
      TournamentName: tournament.TournamentName,
      TournamentId: tournament.TournamentId,
      CategoryId: tournament.CategoryId,
      CategoryName: category.CategoryName,
      SportId: sport.SportId,
      SportName: sport.SportName,
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  checkList(e) {
    return this.selectedLeagueData.find(x => x.TournamentId == e) != undefined;
  }

  selectedLeagueviaAll(e, sport, state) {
    // //console.log('selectedLeagueviaAll--',e)

    const cbData = {
      TournamentName: e.TournamentName,
      TournamentId: e.TournamentId,
      CategoryId: e.CategoryId,
      CategoryName: e.CategoryName,
      SportId: sport.SportId,
      SportName: sport.SportName,
    };

    if (state) {
      if (this.selectedLeagueData.find(x => x.TournamentId == e.TournamentId) == undefined) {
        this.selectedLeagueData.push(cbData);
      }
    } else {
      if (this.selectedLeagueData.find(x => x.TournamentId == e.TournamentId) != undefined) {
        // this.selectedLeagueData.splice(this.selectedLeagueData.indexOf(x => x.TournamentId == e.TournamentId), 1);
        this.selectedLeagueData = this.selectedLeagueData.filter(x => x.TournamentId != e.TournamentId);
      }
    }
  }

  selectAll(e, cntrl, sport) {
    e.level.forEach(cb => {
      cb.checked = cntrl.source.checked;
      this.selectedLeagueviaAll(cb, sport, cntrl.source.checked);
    });

    if (cntrl.source.checked) {
      this._DataHelper.setLeagueData(this.selectedLeagueData);
    } else {
      // TEST
      this.selectedLeagueData = this.selectedLeagueData.filter(x => x.CategoryId != e.CategoryId);

      this._DataHelper.setLeagueData(this.selectedLeagueData); // e.CategoryId
    }
  }

  openAll(e, category, sport, i, k) {
    this.selectedLeagueData = [];

    e.level.forEach(cb => {
      const cbData = {
        TournamentName: cb.TournamentName,
        TournamentId: cb.TournamentId,
        CategoryId: category.CategoryId,
        CategoryName: category.CategoryName,
        SportId: sport.SportId,
        SportName: sport.SportName,
      };

      this.selectedLeagueData.push(cbData);
      this._DataHelper.setLeagueData(this.selectedLeagueData);
      this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
    });

    this.getTourementsByCountryID(sport.SportId, category.CategoryId, i, k);
    //openAll(mainData[i].level[k], item2, item);
  }

  getSports(__dayFilter = 300) {
    if (this.lastReturned_dayFilter != __dayFilter || this.lastReturned_dayFilter == 0) {
      this._ApiService.getSports(__dayFilter).then(x => {
        this.mainData = x.map(x => {
          x['level'] = [];
          x['loading'] = false;
          x['state'] = false;
          return x;
        });
        this.lastReturned_dayFilter = __dayFilter;
      });
    }
  }

  getCountriesBySportsID(_sportID, _index) {
    ////console.log(this.mainData[_index].level.length);
    if (this.mainData[_index].level.length == 0 && !this.mainData[_index].state) {
      this.mainData[_index]['loading'] = true;
      this._ApiService.getCountriesBySportsID(this._dayFilter, _sportID).then(x => {
        this.mainData[_index].level = x.map(x => {
          x['level'] = [];
          x['state'] = false;
          x['loading'] = false;
          x['allselected'] = false;
          return x;
        });
        this.mainData[_index]['loading'] = false;
        this.mainData[_index]['state'] = true;
      });
    } else if (this.mainData[_index].level.length != 0 && !this.mainData[_index].state) {
      this.mainData[_index]['state'] = true;
    } else {
      this.mainData[_index]['state'] = false;
    }
    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
    //for bet3000
  }

  getTourementsByCountryID(_sportID, _countriesID, _index, _indexl2) {
    const currentItem = this.mainData[_index].level[_indexl2];
    //////console.log(currentItem);
    //////console.log(currentItem.level.length == 0, !currentItem.state);
    if (currentItem.level.length == 0 && !currentItem.state) {
      currentItem['loading'] = true;
      this._ApiService
        .getTourementsByCountryID(this._dayFilter, _sportID, _countriesID)
        .then(x => {
          currentItem.level = x.map(x => {
            x['checked'] = false;
            return x;
          });
          currentItem['loading'] = false;
          currentItem['state'] = true;
          currentItem['allselected'] = false;

          this._ApiService.getOutrightsByCountryID(this._dayFilter, _sportID, _countriesID).then(x => {
            currentItem.outrights = x.map(x => {
              x['checked'] = false;
              return x;
            });
          });
        })
        .catch(err => {
          console.log('left-sports-menu.desktop', err);
        });
    } else if (currentItem.level.length != 0 && !currentItem.state) {
      currentItem['state'] = true;
    } else {
      currentItem['state'] = false;
    }
    this.mainData[_index].level[_indexl2] = currentItem;
    //////console.log(this.mainData);
    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  ngAfterViewInit() {
    const translator = new TranslatePipe(this._LocalizationService);
    translator.transform('home_live', null);
    //////console.log(translator.transform('home_live', null));

    //
    // if (this._DataHelper.LeagueData != undefined) {
    //   this.selectedLeagueData = this._DataHelper.LeagueData;
    // }
    this._dayFilter = this._DataHelper.leftMenuSportDayFilter;

    //////console.log('Day Filter ', this._dayFilter);

    this.searchFb.valueChanges
      .pipe(filter(query => query.searchInput.length > 2))
      .pipe(debounceTime(500))
      .pipe(distinctUntilChanged())
      .subscribe(val => {
        this.getSearch(val.searchInput);
        ////console.log('Search REQ', val);
      });

    this._ActivatedRoute.queryParams.subscribe(p => {
      if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();
    });
  }

  ngOnInit() {
    if (this._DataHelper.leftMenuSportData != undefined) {
      if (this._DataHelper.leftMenuSportData.length != 0) this.mainData = this._DataHelper.leftMenuSportData;
      else this.getSports();
    } else this.getSports();

    this.changeDayFilter({ source: null, value: '300' });
  }

  ///Search
  searchFocus(e) {
    if (e) {
      this.searchState = e;
      this.searchFb.getRawValue().searchInput.length > 2 ? this.getSearch(this.searchFb.getRawValue().searchInput) : null;
    } else {
      this.searchState = e;
    }
  }

  getSearch(e) {
    this.searchFb.getRawValue().searchInput.length == 0 ? this.searchFb.setValue({ searchInput: e }) : null;
    ////console.log(e);
    this._ApiService.getSearch(e).then(x => {
      this._DataHelper.setSearchData(x);
      this._Router.navigate(['search', e]);
    });
  }

  leagueSlider = [
    {
      FileName: 'angular/dist/assets/images/league/premiere.svg',
      route: '/league',
      TourId: '107',
      CatId: '1',
      LeagueName: 'Premier League',
      height: '30px',
    },
    {
      FileName: 'angular/dist/assets/images/league/Bundesliga_logo.svg',
      route: '/league',
      TourId: '16',
      CatId: '13',
      LeagueName: 'Bundesliga',
      height: '40px',
    },
    {
      FileName: 'angular/dist/assets/images/league/LaLiga.svg',
      route: '/league',
      TourId: '128',
      CatId: '15',
      LeagueName: 'La Liga',
      height: '25px',
    },
    {
      FileName: 'angular/dist/assets/images/league/serie-a-seeklogo.com.svg',
      route: '/league',
      TourId: '236',
      CatId: '14',
      LeagueName: 'Seria A',
      height: '35px',
    },
    {
      FileName: 'angular/dist/assets/images/league/spor_toto_super_lig_logo.svg',
      route: '/league',
      TourId: '133',
      CatId: '16',
      LeagueName: 'Super Lig',
      height: '35px',
    },
    {
      FileName: 'angular/dist/assets/images/league/Ligue_1_logo.svg',
      route: '/league',
      TourId: '167',
      CatId: '99',
      LeagueName: 'Lique 1',
      height: '35px',
    },
  ];

  getFav(matchInfo) {
    if (matchInfo.checked == true) {
      matchInfo.checked = false;
    } else {
      this.favoriteList.push(matchInfo);
      localStorage.setItem('favorited', JSON.stringify(this.favoriteList));
      matchInfo.checked = true;
    }
    //Favori Mantığı kontrol edin
    this.favoriteList = [];
  }

  add2TournamentFavs(tour, cat) {
    const favitem = {
      tourid: tour.TournamentId,
      tourname: tour.TournamentName,
      catid: cat.CategoryId,
      catname: cat.CategoryName,
      count: tour.TournamentSportEventCount,
    };
    tour['checked'] = !tour['checked'];
    this._UiHelper.favTournamentChanged(favitem);
  }

  isOpenLeagueMenu = true;
  isOpenSportsMenu = true;

  toggleLeagueMenu() {
    this.isOpenLeagueMenu = !this.isOpenLeagueMenu;
  }

  toggleSportsMenu() {
    this.isOpenSportsMenu = !this.isOpenSportsMenu;
  }

  openFavPreMatches() {
    this.favPreMatchesClicked.emit();
  }

  openStats(e) {
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialog',
      panelClass: 'standingsDialogClass',
      height: '90%',
      width: '90%',
      data: {
        tournamentId: '',
        sportId: '',
        betradarMatchId: '',
        type: e,
      },
    });
  }
}
